var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V6H5V10H7V8H9H14H16V10V12V14H14H9H7V12H4H3V11V6H0V0ZM14 10H9V12H14V10Z",
    fill: "#BCD4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskMd);
export default __webpack_public_path__ + "static/media/task_md.72985477ea22a806adef69f8b8b62938.svg";
export { ForwardRef as ReactComponent };